import React from "react";
import PropTypes from "prop-types";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from "styled-components";

const StyledImage = styled(GatsbyImage)`
  width: ${({ $width }) =>
    $width && $width > 0 ? `${$width}px !important` : "100%"};
  height: ${({ $height }) =>
    $height && $height > 0 ? `${$height}px` : "100%"};
  max-width: 100%;
`;

const DefaultImage = styled.img`
  width: ${({ $width }) =>
    $width && $width > 0 ? `${$width}px !important` : "100%"};
  height: ${({ $height }) =>
    $height && $height > 0 ? `${$height}px` : "100%"};
  max-width: 100%;
`;

const Image = ({
  className,
  image,
  src,
  alt,
  style,
  loading,
  objectPosition,
  objectFit,
  width,
  height,
  ...otherProps
}) => {
  const imgData = getImage(image?.localFile || image);
  const fallbackAlt = alt || image?.altText || src || "bilde";

  if (imgData) {
    return (
      <StyledImage
        className={className}
        imgClassName={className}
        $height={height}
        $width={width}
        style={style}
        imgStyle={style}
        image={imgData}
        alt={fallbackAlt}
        objectFit={objectFit}
        loading={loading || "lazy"}
        objectPosition={objectPosition || image?.focalPoint?.objectPosition}
        {...otherProps}
      />
    );
  }
  return (
    <DefaultImage
      className={className}
      style={style}
      src={src}
      alt={fallbackAlt}
      loading={loading || "lazy"}
      $height={height}
      $width={width}
      {...otherProps}
    />
  );
};

export default Image;

Image.propTypes = {
  className: PropTypes.string,
  image: PropTypes.object,
  src: PropTypes.string,
  alt: PropTypes.string,
  style: PropTypes.object,
  loading: PropTypes.string,
  objectPosition: PropTypes.string,
  objectFit: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};
